import script from "./ConciergeChat.vue?vue&type=script&setup=true&lang=js"
export * from "./ConciergeChat.vue?vue&type=script&setup=true&lang=js"

import "./ConciergeChat.vue?vue&type=style&index=0&id=6913e58a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6913e58a"]])

export default __exports__